/* eslint-disable max-len */
import { Routes } from '@angular/router';
import { authGuard } from '@front-shared-lib';
import { validEditActionGuard } from '../../../shared-lib/src/lib/guards/validate-edit-action-guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./components/auth/login/login.component').then(m => m.LoginComponent) },
  { path: 'verify/:rememberMeDays', loadComponent: () => import('./components/auth/verify/verify.component').then(m => m.VerifyComponent) },

  {
    path: '',
    loadComponent: () => import('./components/pane/dashboard/dashboard/dashboard.component')
      .then(m => m.DashboardComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./components/pane/dashboard/home/home.component')
          .then(m => m.HomeComponent)
      },
      {
        path: 'company',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/company-related/company/company-list/company-list.component')
              .then(m => m.CompanyListComponent)
          },
          {
            path: 'view/:id',
            loadComponent: () => import('./components/pane/company-related/company/view-company/view-company.component')
              .then(m => m.ViewCompanyComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/company-related/company/add-update-company/add-update-company.component')
              .then(m => m.AddUpdateCompanyComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'vendor-manager',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/manager-related/vendor-manager/vendor-manager-list/vendor-manager-list.component')
              .then(m => m.VendorManagerListComponent)
          },
          {
            path: 'view/:id',
            loadComponent: () => import('./components/pane/manager-related/vendor-manager/view-vendor-manager/view-vendor-manager.component')
              .then(m => m.ViewVendorMangerComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/manager-related/vendor-manager/add-update-vendor-manager/add-update-vendor-manager.component')
              .then(m => m.AddUpdateVendorManagerComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'delivery-manager',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/manager-related/delivery-manager/delivery-manager-list/delivery-manager-list.component')
              .then(m => m.DeliveryManagerListComponent)
          },
          {
            path: 'view/:id',
            loadComponent: () => import('./components/pane/manager-related/delivery-manager/view-delivery-manager/view-delivery-manager.component')
              .then(m => m.ViewDeliveryManagerComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/manager-related/delivery-manager/add-update-delivery-manager/add-update-delivery-manager.component')
              .then(m => m.AddUpdateDeliveryManagerComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'ecommerce-order',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/company-related/ecommerce-order/ecommerce-order-list/ecommerce-order-list.component')
              .then(m => m.EcommerceOrderListComponent)
          },
          {
            path: 'view/:id',
            loadComponent: () => import('./components/pane/company-related/ecommerce-order/view-ecommerce-order/view-ecommerce-order.component')
              .then(m => m.ViewEcommerceOrderComponent)
          },
          {
            path: 'receipt/view/:id',
            loadComponent: () => import('../../../shared-lib/src/lib/components/view-one/view-receipt/view-receipt.component')
              .then(m => m.ViewReceiptComponent),
            data: { animation: 'ViewReceiptComponent' }
          }
        ]
      },
      {
        path: 'auto-tax',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/auto-tax/auto-tax-list/auto-tax-list.component')
              .then(m => m.AutoTaxListComponent)
          },
          {
            path: 'view/:id',
            loadComponent: () => import('./components/pane/auto-tax/view-auto-tax/view-auto-tax.component')
              .then(m => m.ViewAutoTaxComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/auto-tax/add-update-auto-tax/add-update-auto-tax.component')
              .then(m => m.AddUpdateAutoTaxComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'refresh-token',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/refresh-token/refresh-token-list/refresh-token-list.component')
              .then(m => m.RefreshTokenListComponent)
          }
        ]
      },
      {
        path: 'notif-key',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/notification/notif-key/notif-key-list/notif-key-list.component')
              .then(m => m.NotifKeyListComponent)
          },
          {
            path: 'view/:id',
            loadComponent: () => import('./components/pane/notification/notif-key/view-notif-key/view-notif-key.component')
              .then(m => m.ViewNotifKeyComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/notification/notif-key/add-update-notif-key/add-update-notif-key.component')
              .then(m => m.AddUpdateNotifKeyComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'ecommerce-cut',
        children: [
          {
            path: '',
            redirectTo: 'view',
            pathMatch: 'full'
          },
          {
            path: 'view',
            loadComponent: () => import('./components/pane/ecommerce-cut/ecommerce-cut-view/ecommerce-cut-view.component')
              .then(m => m.EcommercCutListComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/ecommerce-cut/add-update-ecommerce-cut/add-update-ecommerce-cut.component')
              .then(m => m.AddUpdateEcommercCutComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'operational-location',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/operational-location/operational-location-list/operational-location-list.component')
              .then(m => m.OperationalLocationListComponent)
          },
          {
            path: 'view/:id',
            loadComponent: () => import('./components/pane/operational-location/view-operational-location/view-operational-location.component')
              .then(m => m.ViewOperationalLocationComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/operational-location/add-update-operational-location/add-update-operational-location.component')
              .then(m => m.AddUpdateOperationalLocationComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'ecommerce-order-refund/:id',
        loadComponent: () => import('./components/pane/user-related/fund-transfer/ecommerce-order-refund/ecommerce-order-refund-list/ecommerce-order-refund-list.component')
          .then(m => m.EcommerceOrderRefundListComponent)
      },
      {
        path: 'un-reliable-user',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/un-reliable/un-reliable-user/un-reliable-user/un-reliable-user-list/un-reliable-user-list.component')
              .then(m => m.UnReliableUserListComponent)
          },
          {
            path: 'history/:id',
            loadComponent: () => import('./components/pane/un-reliable/un-reliable-user/un-reliable-user-history/un-reliable-user-history-list/un-reliable-user-history-list.component')
              .then(m => m.UnReliableUserHistoryListComponent)
          }
        ]
      },
      {
        path: 'un-reliable-vendor',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/un-reliable/un-reliable-vendor/un-reliable-vendor/un-reliable-vendor-list/un-reliable-vendor-list.component')
              .then(m => m.UnReliableVendorListComponent)
          },
          {
            path: 'history/:id',
            loadComponent: () => import('./components/pane/un-reliable/un-reliable-vendor/un-reliable-vendor-history/un-reliable-vendor-history-list/un-reliable-vendor-history-list.component')
              .then(m => m.UnReliableVendorHistoryListComponent)
          }
        ]
      },
      {
        path: 'user-wallet',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/user-related/wallet/user-wallet/user-wallet-list/user-wallet-list.component')
              .then(m => m.UserWalletListComponent)
          },
          {
            path: 'history/:id',
            loadComponent: () => import('./components/pane/user-related/wallet/user-wallet-history/user-wallet-history-list/user-wallet-history-list.component')
              .then(m => m.UserWalletHistoryListComponent)
          }
        ]
      },
      {
        path: 'flying-mail',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/admin-domain-related/admin-flying-mail/admin-mail-list/admin-mail-list.component')
              .then(m => m.AdminMailListComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/admin-domain-related/admin-flying-mail/admin-add-update-mail/admin-add-update-mail.component')
              .then(m => m.AdminAddUpdateMailComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'auto-dns',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/admin-domain-related/admin-auto-dns/admin-domain-list/admin-domain-list.component')
              .then(m => m.AdminDomainListComponent)
          },
          {
            path: 'setup',
            loadComponent: () => import('./components/pane/admin-domain-related/admin-auto-dns/admin-set-up-dns/admin-set-up-dns.component')
              .then(m => m.AdminSetUpDnsComponent),
            canActivate: [validEditActionGuard]
          },
          {
            path: 'add-sub-domain',
            loadComponent: () => import('./components/pane/admin-domain-related/admin-auto-dns/admin-add-sub-domain/admin-add-sub-domain.component')
              .then(m => m.AdminAddSubDomainComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'item-return',
        loadComponent: () => import('./components/pane/item-related/item-return/item-return-list/item-return-list.component')
          .then(m => m.ItemReturnListComponent)
      },
      {
        path: 'item-complaint',
        loadComponent: () => import('./components/pane/item-related/item-complaint/item-complaint-list/item-complaint-list.component')
          .then(m => m.ItemComplaintListComponent)
      },
      {
        path: 'profile/:id',
        loadComponent: () => import('./components/pane/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'settings',
        loadComponent: () => import('./components/pane/user-related/settings/settings.component').then(m => m.SettingsComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./components/pane/user-related/user-list/user-list.component').then(m => m.UserListComponent)
      },
      {
        path: 'user-ips',
        loadComponent: () => import('./components/pane/user-related/user-ips/user-ips-list/user-ips-list.component')
          .then(m => m.UserIpsListComponent)
      },
      {
        path: 'user-ips-analytics',
        loadComponent: () => import('./components/pane/user-related/user-ips/user-ips-analytics/user-ips-analytics.component').then(m => m.UserIpsAnalyticsComponent)
      },
      {
        path: 'login-history/:id',
        loadComponent: () => import('./components/pane/user-related/user-login-attempts/user-login-attempts-list/user-login-attempts-list.component')
          .then(m => m.UserLoginAttemptsListComponent)
      },
      {
        path: 'manage-user/:id',
        loadComponent: () => import('./components/pane/user-related/manage-user-profile/manage-user-profile.component')
          .then(m => m.ManageUserProfileComponent)
      },
      {
        path: 'subscribe/:id',
        loadComponent: () => import('./components/pane/subscriptions/subscribe/subscribe.component')
          .then(m => m.SubscribeComponent)
      },
      {
        path: 'subscription',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            loadComponent: () => import('./components/pane/subscriptions/subscription-list/subscription-list.component')
              .then(m => m.SubscriptionListComponent)
          },
          {
            path: 'packages',
            loadComponent: () => import('./components/pane/subscriptions/subscription-packages/subscription-packages.component')
              .then(m => m.SubscriptionPackagesComponent)
          },
          {
            path: 'package-detail',
            loadComponent: () => import('./components/pane/subscriptions/subscription-view/subscription-view.component')
              .then(m => m.SubscriptionViewComponent)
          },
          {
            path: ':editAction',
            loadComponent: () => import('./components/pane/subscriptions/add-subscription/add-update-subscription.component')
              .then(m => m.AddUpdateSubscriptionComponent),
            canActivate: [validEditActionGuard]
          }
        ]
      },
      {
        path: 'data-bin',
        loadComponent: () => import('./components/pane/track/data-bin-list/data-bin-list.component')
          .then(m => m.DataBinListComponent)
      },
      {
        path: 'droplet-metrics',
        children: [
          {
            path: '',
            redirectTo: 'web',
            pathMatch: 'full'
          },
          {
            path: 'web',
            loadComponent: () => import('./components/pane/droplet-metrics/web-droplet/web-droplet.component')
              .then(m => m.WebDropletComponent)
          },
          {
            path: 'mail',
            loadComponent: () => import('./components/pane/droplet-metrics/mail-droplet/mail-droplet.component')
              .then(m => m.MailDropletComponent)
          }
        ]
      },
      {
        path: 'audit-log/parent/:id',
        loadComponent: () => import('./components/pane/track/audit-log/audit-log-list/audit-log-list.component')
          .then(m => m.AuditLogListComponent)
      },
      {
        path: 'audit-log/user/:id',
        loadComponent: () => import('./components/pane/track/audit-log/audit-log-group/audit-log-group.component')
          .then(m => m.AuditLogGroupComponent)
      },
      {
        path: 'user-suspicious-activity',
        loadComponent: () => import('./components/pane/user-related/user-suspicious-activity/user-suspicious-activity.component')
          .then(m => m.UserSuspiciousAuditComponent)
      },
      {
        path: 'not-found',
        loadComponent: () => import('./components/pane/not-found/not-found.component')
          .then(m => m.NotFoundComponent)
      }
    ]
  }
];
